// 学生认证
export default [
  // 目录
  {
    path: '/CourseCatalogue',
    name: 'CourseCatalogue',
    meta: {
      // IndexHeader: true,
      itemIndex: 0
    },
    component: () => import(/* webpackChunkName: "PersonalCenter" */ '@/components/certification/CourseCatalogue')
  },
  // 详情
  {
    path: '/AuthenticationCenter',
    name: 'AuthenticationCenter',
    meta: {
      // IndexHeader: true,
      itemIndex: 0
    },
    component: () => import(/* webpackChunkName: "PersonalCenter" */ '@/components/certification/content')
  },
  // 证书列表
  {
    path: '/CourseDetails',
    name: 'CourseDetails',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () => import(/* webpackChunkName: "PersonalCenter" */ '@/components/certification/CourseDetails')
  },
  {
    path: '/TemplatePreview',
    name: 'TemplatePreview',
    component: () => import(/* webpackChunkName: "PersonalCenter" */ '@/components/certification/TemplatePreview')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/sub-task/studentCertification.js